<template>
  <Page :response="response">
    <div class="index-table">
      <div class="index-table-nav px-i">
        <h2 class="index-table-nav-title">
          {{ indexTitle('Template', voucherTemplates.length) }}
        </h2>
        <router-link :to="{ name: 'New Template' }" role="button" class="btn btn-secondary ihjoz-rounded-button">
          New
        </router-link>
      </div>
      <div v-if="voucherTemplates.length" class="index-table-body">
        <div class="index-table-body-content voucher-templates-table">
          <div class="table-header d-md-flex">
            <div class="table-header-wrapper">
              <div class="table-header-wrapper-title col-6">
                Type
              </div>
              <div class="table-header-wrapper-title col-6">
                Internal Name
              </div>
              <div class="table-header-wrapper-title col-12">
                Document Title
              </div>
            </div>
          </div>
          <VoucherTemplatesList
            v-model="voucherTemplates"
            :use-drag-handle="true"
            lock-axis="y"
            @input="rankTemplates($event)">
            <SortableVoucherTemplate
              v-for="(template, index) in voucherTemplates"
              :key="index"
              :index="index"
              :item="template"
              :voucher-template="template" />
          </VoucherTemplatesList>
        </div>
      </div>
      <EmptyList v-else resource-name="voucher_template" create-route="New Template" />
    </div>
  </Page>
</template>

<script>
import VoucherTemplateMixin from "./VoucherTemplateMixin";
import VoucherTemplateStore from "./VoucherTemplateStore";
import VoucherTemplatesList from "./VoucherTemplatesList.vue";
import SortableVoucherTemplate from "./SortableVoucherTemplate.vue";
import EmptyList from "@shared/components/UI/EmptyList.vue";
import CompanyStore from "@shared/components/Company/CompanyStore";

const responseStore = {
  response: null
};

const fetchResource = async (to, from, next) => {
  responseStore.response = await VoucherTemplateStore.fetchAll(
    { companyId: CompanyStore.currentCompany.id });

  next();
};

export default {
  name: "VoucherTemplateIndex",

  title () {
    return `Templates - ${Dashboard.currentTenant.name}`;
  },

  components: {
    EmptyList,
    VoucherTemplatesList,
    SortableVoucherTemplate
  },

  mixins: [VoucherTemplateMixin],

  beforeRouteEnter: fetchResource,
  beforeRouteUpdate: fetchResource,

  data () {
    return {
      responseStore: responseStore,
      voucherTemplates: responseStore.response.collection
    };
  },

  computed: {
    response () {
      return this.responseStore.response;
    }
  },

  methods: {
    async rankTemplates (e) {
      this.handleResponseInplace(await VoucherTemplateStore.rankObject(e, "voucher_template"));
    }
  }
};
</script>
